import { useState } from "react";
import CreateMappingTestCaseModal from "./CreateMappingTestCaseModal";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { Plus } from "lucide-react";

type Props = { integrationID: string; endpointCollectionID: string; categories: Array<string> };

const MappingTestCaseCreateButton = ({
  integrationID,
  endpointCollectionID,
  categories,
}: Props) => {
  const [isModalShown, setIsModalShown] = useState(false);

  return (
    <>
      <Button
        variant={ButtonVariant.PrimaryGray}
        onClick={() => setIsModalShown(true)}
        leftIcon={<Plus size={16} />}
      >
        Add Test Case
      </Button>
      <CreateMappingTestCaseModal
        integrationID={integrationID}
        endpointCollectionID={endpointCollectionID}
        categories={categories}
        isShown={isModalShown}
        onHide={() => setIsModalShown(false)}
      />
    </>
  );
};

export default MappingTestCaseCreateButton;
